import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { UserRoleNames } from '../../core/models/users';
import { RouteGuard } from '../../core/route-guards/route-guard.guard';
import { SessionListComponent } from './components/session-list/session-list.component';
import { SessionMainPanelComponent } from './components/session-main-panel/session-main-panel.component';
import { SessionProcessesComponent } from './components/session-processes/session-processes.component';
import { ClientSessionComponent } from './components/client-session/client-session.component';
import { ActionLogsComponent } from '../shared/components/actionlogs-component/action-logs.component';


const routes: Routes = [
  {
    path: 'Session List',
    component: SessionMainPanelComponent,
    canActivateChild: [RouteGuard],
    data: { role: [UserRoleNames.GlobalAdmin, UserRoleNames.PowerUser, UserRoleNames.DeploymentAdmin] },
    children: [
      {
        path: 'Sessions', component: SessionListComponent
      },

      {
        path: 'Logs', component: ActionLogsComponent
      },
      { path: 'Processes', component: SessionProcessesComponent },
      { path: '', pathMatch: 'full', redirectTo: 'Sessions' }
    ],
  },
  //{ path: 'Client Sessions', component: ClientSessionComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class SessionRoutingModule { }
